var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-pie',{attrs:{"data":_vm.chartData,"colors":_vm.chartColors,"settings":_vm.chartSettings,"height":_vm.chartHeight,"width":_vm.chartWidth,"theme-name":'dark'}})}
var staticRenderFns = []

export { render, staticRenderFns }